import Footer from "../Components/Footer";

export default function Guest({ children }) {
    return (
        <div className="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-slate-100">
            <main>
                {children}
            </main>

            <Footer />
        </div>
    );
}
